import dynamic from "next/dynamic";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { PHead } from "../components/global/PHead/PHead";

const LoyaltyCardScreen = dynamic(
  () => import("../components/screens/S-AppleWallet/LoyaltyCardScreen"),
  { ssr: false }
);
import { globalTranslationFiles } from "../utils/help/localization/localization";
import { getRestaurantStaticProps } from "../utils/help/staticProps/restaurantStaticProps";
import { Restaurant } from "../utils/types";

function AppleWallet(props: { restaurantInfo: Restaurant }) {
  return (
    <>
      <PHead
        restaurantInfo={props.restaurantInfo}
        title="Add to Apple Wallet"
      />
      <LoyaltyCardScreen />
    </>
  );
}

export async function getStaticProps({ locale }: { locale: any }) {
  const { restaurantInfo, socialMediaInfo } = await getRestaurantStaticProps();

  return {
    props: {
      ...(await serverSideTranslations(locale, [
        ...globalTranslationFiles,
        "common",
        "loyalty-card",
      ])),
      restaurantInfo,
      socialMediaInfo,
    },
  };
}

AppleWallet.displayName = "AppleWallet";

export default AppleWallet;
